import { Box, Typography, Stack, Dropdown, MenuButton, Menu } from '@mui/joy';
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded';
import { useTheme } from '@mui/material';
import { useMediaQuery } from '@mui/material';
import { useState, useCallback } from 'react';

export function PageHeader({ title, subtitle, suffix, children, moreActions, hideOnMobile }) {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down('md'));  
  const showHeader = !hideOnMobile || !isSm;

  const [open, setOpen] = useState(false);

  const handleOpenChange = useCallback((e, isOpen) => {
    if (e.stopMenuClose) return;
    setOpen(isOpen);
  }, []);

  const moreActionsMenu = (
    <Dropdown open={open} onOpenChange={handleOpenChange}>
      <MenuButton variant="plain" color="neutral" sx={{ px: 1 }}>
        <MoreVertRoundedIcon/>
      </MenuButton>
      <Menu placement="bottom-end">              
        { moreActions }
      </Menu>
    </Dropdown>
  );

  return (
    <Stack direction="column" gap={2}>
      {showHeader && <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Box sx={{ width: '100%', flex: 1 }}>
          <Stack direction="row" alignItems="flex-start" justifyContent="space-between" gap={1} sx={{ width: '100%', flex: 1 }}>
            <Stack gap={1} direction={"row"} alignItems="baseline">
              <Typography level="h2">{ title }</Typography>          
              {suffix && <Typography level="title-sm">{suffix}</Typography>}
            </Stack>
            {moreActions && isSm && moreActionsMenu}
          </Stack>
          { subtitle && <Typography level={isSm ? "body-sm" : "body-md" } sx={{ mb: 0.5 }}>{ subtitle }</Typography> }
        </Box>
        <Stack direction="row" alignItems="center" justifyContent="flex-end" gap={1}>
          {children && !isSm && children }          
          {moreActions && !isSm && moreActionsMenu}   
        </Stack>           
      </Stack>}
      {children && isSm && <Stack gap={{ xs: 2, sm: 1 }} direction={{ xs: "column", sm: "row" }} alignItems="center">
        { children }
      </Stack>}
    </Stack>
  );  
}